<template>
  <div class="appointment-schedule-date">
    <AppointmentScheduleDateItem
      v-for="(item, index) in list"
      :key="index"
      :item="item"
      @click="showNumber(item)"
    />
    <AppointmentNumberPicker
      v-model="showPopupWindow"
      :doctor-info="doctorInfo"
      :number-list="numberList"
      @dateSelected="dateSelected"
    />
  </div>
</template>

<script>
import AppointmentNumberPicker from "./AppointmentNumberPicker";
import AppointmentScheduleDateItem from "./AppointmentScheduleDateItem";

export default {
  components: { AppointmentNumberPicker, AppointmentScheduleDateItem },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    doctorInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hideEmpty: {
      type: Boolean,
      default: false
    },
    qrtype: {
      type: String,
      default: "1"
    }
  },
  data() {
    return {
      showPopupWindow: false,
      numberList: []
    };
  },
  methods: {
    showNumber(item) {
      if (item.remain === "0") {
        return;
      }
      this.numberList = [];
      this.$http
        .post(this.$api.APPOINTMENT_SCHEDULE_NUMBERS, {
          appointOfficeCode:
            item.appointOfficeCode || this.doctorInfo.departmentId,
          appointDoctorCode: this.doctorInfo.doctorId || item.appointDoctorCode,
          appointmentDate: item.appointmentDate,
          timeFrameCode: item.timeFrameCode
        })
        .then(res => {
          this.numberList = res.map(number => {
            return {
              ...item,
              ...number
            };
          });
        });
      this.showPopupWindow = true;
    },
    dateSelected(item) {
      this.$router.push({
        name: "appointment-registration",
        query: {
          ...item,
          ...this.doctorInfo,
          qrtype: this.qrtype
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.appointment-schedule-date {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  font-weight: 500;
}
</style>
